import React, { useState } from "react";

const ImageCarousel = ({ images }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  // Handle clicking on navigation dots
  const handleImageChange = (index) => {
    setSelectedIndex(index);
  };

  return (
    <div className="text-center">
      {/* Display Selected Image */}
      <img
        src={images[selectedIndex]}
        alt={`Product ${selectedIndex + 1}`}
        className="block w-full rounded shadow-sm object-cover"
      />

      {/* Navigation Dots */}
      <div className="mt-2 flex items-center justify-center">
        {images.map((_, index) => (
          <button
            key={index}
            className={`dot ${selectedIndex === index ? "active" : ""}`}
            onClick={() => handleImageChange(index)}
          ></button>
        ))}
      </div>

      {/* Styling for Navigation Dots */}
      <style jsx>{`
        .dot {
          width: 10px;
          height: 10px;
          margin: 5px;
          border-radius: 50%;
          background-color: #ccc;
          border: none;
          cursor: pointer;
          transition: background 0.3s;
        }
        .dot.active {
          background-color: #007bff;
        }
      `}</style>
    </div>
  );
};

export default ImageCarousel
